import Vue from "vue";

const state = {
  subcategoryTypes: [],
  subcategory_type: {},
  totalSuppliers: 0
};

const getters = {};

const actions = {
  LOAD_SUBCATEGORY_TYPE: function({ commit, rootState }, payload) {
    return Vue.prototype.$axios
      .get("/product_subcategory_types/" + payload.subcategory_typeId)
      .then(response => {
        commit("SET_SUBCATEGORY_TYPE", response.data.subcategory_type);
      });
  },
  LOAD_SUBCATEGORY_TYPES: function({ commit, rootState }, payLoad) {
    let idQuery = payLoad.id ? "&id=" + payLoad.id : "";
    let approvedQuery =
      payLoad.approved === 1 || payLoad.approved === 0
        ? "&approved=" + payLoad.approved
        : "";
    let activeQuery =
      payLoad.active === 1 || payLoad.active === 0
        ? "&active=" + payLoad.active
        : "";
    let subcategory_typeIdQuery = payLoad.subcategory_typeId
      ? "&subcategory_type_id=" + payLoad.subcategory_typeId
      : "";
    let subcategory_typeNameQuery = payLoad.subcategory_typeName
      ? "&subcategory_type_name=" + payLoad.subcategory_typeName
      : "";

    return Vue.prototype.$axios
      .get(
        "/product_subcategory_types?from=" +
          payLoad.from +
          "&limit=" +
          payLoad.to +
          idQuery +
          approvedQuery +
          subcategory_typeIdQuery +
          activeQuery +
          subcategory_typeNameQuery
      )
      .then(response => {
        commit("SET_SUBCATEGORY_TYPES", response.data.productSubcategoryTypes);
        commit("SET_TOTAL_SUBCATEGORY_TYPES", response.data.meta.total);
        return response;
      });
  },
  UPDATE_SUBCATEGORY_TYPE: function({ commit, rootState, dispatch }, payLoad) {
    return Vue.prototype.$axios
      .post("/product_subcategory_types/" + payLoad.id, payLoad, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {});
  },
  CREATE_SUBCATEGORY_TYPE: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .post("product_subcategory_types", payload)
      .then(response => {});
  },
  DESTROY_SUBCATEGORY_TYPE: async function({ commit, dispatch }, payload) {
    return await Vue.prototype.$axios
      .delete("product_subcategory_types/" + payload)
      .then(response => {});
  }
};

const mutations = {
  SET_SUBCATEGORY_TYPES: (state, subcategoryTypes) => {
    state.subcategoryTypes = subcategoryTypes;
  },
  SET_TOTAL_SUBCATEGORY_TYPES: (state, totalSuppliers) => {
    state.totalSuppliers = totalSuppliers;
  },
  SET_SUBCATEGORY_TYPE: (state, subcategory_type) => {
    state.subcategory_type = subcategory_type;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
